module.exports = __webpack_public_path__ + "static/media/BO.e463abda.png";